import React from 'react';
import { required, DateField, SaveButton, Toolbar, SimpleForm, Edit, Create, EditButton, Filter, List, Datagrid,
  TextField, TextInput, BooleanField, BooleanInput} from 'react-admin';
import DeleteWithConfirmation from './components/DeleteWithConfirmation';

const SecretsFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="search_username" alwaysOn resettable />
    </Filter>
);

export const SecretsList = (props) => (
    <List {...props} filters={<SecretsFilter />} perPage={25} bulkActionButtons={false}>
        <Datagrid rowClick="edit">
            <TextField source="name" label="Name" />
            <DateField source="updated_at" label="Update Date" />
            <DateField source="created_at" label="Creation Date" />
            <DeleteWithConfirmation {...props}/>
        </Datagrid>
    </List>
);

const SecretsTitle = ({ record }) => {
    return <span>Secrets {record ? `"${(record.name)}"` : ''}</span>;
};

const CustomToolbar = props => (
    <Toolbar {...props}>
        <SaveButton />
        <span style={{ paddingLeft: '20px' }}>Last update </span><DateField source="updated_at" label="Update date" showTime style={{ paddingLeft: '10px' }} />
    </Toolbar>
);

export const TheForm = ({ permissions, ...props }) => (
  <SimpleForm toolbar={<CustomToolbar /> } redirect={false} {...props} >
    <TextInput source="name" label="Name" validate={required()} style={{width: '30%'}}/>
    <TextInput source="value" label="Value" validate={required()} multiline minRows={5} style={{width: '50%'}}/>
  </SimpleForm>
);

export const SecretsEdit = ({ permissions, ...props }) => {
return (
  <Edit title={<SecretsTitle />} mutationMode="pessimistic" {...props}>
    <TheForm formType="edit" permissions={permissions} {...props} />
  </Edit>
)
};

export const SecretsCreate = ({ permissions, ...props }) => {
return (
  <Create title="New Secret" mutationMode="pessimistic" {...props}>
    <TheForm formType="create" permissions={permissions} {...props} />
  </Create>
)
};